import React, { useEffect, useState } from 'react';
import { useSlider } from './SliderStore';
import { useForm } from 'antd/es/form/Form';
import MediaManager from '../Media/MediaManager';
import emptyimg from './../../assets/images/emptyimage.jpg'
import { MAIN_URL } from '../../Constants';
import { Button, Form, Image, Input, Modal } from 'antd';
//    `img`, `titleuz`, `btntextuz`, `btnurl`, `subtitleuz`, `id`, `titleru`, `btntextru`, `subtitleru`
function Edit(props) {

    let [open, setOpen] = useState(false);
    let [img, setImg] = useState(emptyimg);
    let { updateSlider, ed } = useSlider();
    let [form] = useForm();
    useEffect(() => {
        form.setFieldsValue(ed)
        setImg(ed.img)
    }, [ed])

    return (
        <>
            <Modal width={'80%'} title="Rasm yuklash" open={open} footer={null} onCancel={() => setOpen(false)}>
                <MediaManager onSelect={(e) => { setImg(e); setOpen(false); }} />
            </Modal>
            <Form onFinish={(values) => {
                values.img = img;
                updateSlider(values);
                setOpen(false)
            }} layout='vertical' labelAlign="left" form={form}>
                <Form.Item label="Rasm" name="img">
                    <Button onClick={() => setOpen(true)}>Rasm yuklash</Button>
                    <Image src={MAIN_URL + '/' + img} width={100} height={100} style={{ objectFit: 'cover' }} />
                </Form.Item>
                <Form.Item label="ID" name="id">
                    <Input hidden />
                </Form.Item>
                <Form.Item label="Uzb matn" name="titleuz">
                    <Input />
                </Form.Item>
                <Form.Item label="Ru matn" name="titleru">
                    <Input />
                </Form.Item>
                <Form.Item label="Uzb tugma matn" name="btntextuz">
                    <Input />
                </Form.Item>
                <Form.Item label="Ru tugma matn" name="btntextru">
                    <Input />
                </Form.Item>
                <Form.Item label="Uzb qo'shimcha matn" name="subtitleuz">
                    <Input />
                </Form.Item>
                <Form.Item label="Ru qo'shimcha matn" name="subtitleru">
                    <Input />
                </Form.Item>
                <Form.Item label="Tugma URL" name="btnurl">
                    <Input />
                </Form.Item>
                <Form.Item>
                    <Button type="primary" htmlType="submit">Qo'shish</Button>
                </Form.Item>
            </Form>
        </>
    );
}

export default Edit;